import { render, staticRenderFns } from "./diagnosisTagsSub.vue?vue&type=template&id=10668d8a&scoped=true"
import script from "./diagnosisTagsSub.vue?vue&type=script&lang=js"
export * from "./diagnosisTagsSub.vue?vue&type=script&lang=js"
import style0 from "./diagnosisTagsSub.vue?vue&type=style&index=0&id=10668d8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10668d8a",
  null
  
)

export default component.exports